<script setup lang="ts">
import { VolleyballIncidentId } from '@collector/sportsapi-client-legacy'
import BetStatusButton from '@desktop/views/Relation/Sports/components/RelationView/Main/PocketIncidents/BetButton/BetStatusButton.vue'
import PocketIncidents from '@desktop/views/Relation/Sports/components/RelationView/Main/PocketIncidents/PocketIncidents.vue'

import TimeoutButton from './TimeoutButton.vue'
import TimeoutOverButton from './TimeoutOverButton.vue'
</script>

<template>
  <PocketIncidents>
    <template #pocketIncidentButton="{ incidentId, title }">
      <TimeoutButton
        v-if="incidentId === VolleyballIncidentId.Timeout"
        :incidentId
        :title
      />
      <TimeoutOverButton
        v-if="incidentId === VolleyballIncidentId.TimeoutOver"
        :incidentId
        :title
      />
    </template>
    <template #betButtons>
      <BetStatusButton class="w-full" />
    </template>
  </PocketIncidents>
</template>
